import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'jhi-adblocker-detector',
    templateUrl: './adblocker-detector.component.html',
    styleUrls: ['./adblocker-detector.component.scss']
})
export class AdBlockDetectorComponent implements OnInit {
    public adBlockerDetected = false;

    ngOnInit() {
        this.detectAdBlock().then();
    }

    async detectAdBlock() {
        const googleAdUrl = '/fload.js'
        try {
            await fetch(new Request(googleAdUrl)).catch(_ => this.adBlockerDetected = true)
        } catch (e) {
            this.adBlockerDetected = true
        } finally {
            console.log(`AdBlock Enabled: ${this.adBlockerDetected}`)
        }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/components/adblocker-detector/adblocker-detector.component.ts